<template>
	<span>
		<v-checkbox v-model="item[column.value]" :disabled="column.disabled" @change="update"></v-checkbox>
	</span>
</template>

<script>
export default {
	name: "CheckboxCell",
	props: ["item", "column"],
	methods: {
		update(v) {
			this.$store.dispatch("appointmentParticipants/patch", {id: this.item.participant_id, [this.column.value]: v ? true : false })
		},
	},
};
</script>
